import { render, staticRenderFns } from "./ComponenteDialogo.vue?vue&type=template&id=5f419599&scoped=true&"
import script from "./ComponenteDialogo.vue?vue&type=script&lang=ts&"
export * from "./ComponenteDialogo.vue?vue&type=script&lang=ts&"
import style0 from "./ComponenteDialogo.vue?vue&type=style&index=0&id=5f419599&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f419599",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('5f419599', component.options)
    } else {
      api.reload('5f419599', component.options)
    }
    module.hot.accept("./ComponenteDialogo.vue?vue&type=template&id=5f419599&scoped=true&", function () {
      api.rerender('5f419599', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Conecta/SIMSolicitudes/ComponenteDialogo.vue"
export default component.exports